import React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Maitre from "../../Components/Projects/Maitre";
import ScrollMagic from "scrollmagic";
import imagedata from "../../Images/foodanaHero.png";
import Whychoose from "./Whychoose/Whychoose";
import TheArtflavour from "./TheArtflavour/TheArtflavour";
import Buzzing from "./Buzzing/Buzzing";
import FoodrnaContactUs from "./FoodrnaContactUs/FoodrnaContactUs";
import { Helmet } from "react-helmet-async";

const Foodarna = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const controller = new ScrollMagic.Controller();

    const triggerElement = document.getElementById("triggerPinned");

    if (window.innerWidth > 768 && triggerElement) {
      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: 0,
      })
        .setPin(triggerElement)
        .addTo(controller);
    }

    return () => controller.destroy();
  }, []);

  return (
    <>
      <Helmet>
        <title>Owision-Owision Foodrana | Food Delivery & Culinary Experience</title>
        <meta
          name="description"
          content="Explore Owision's Foodrana — your go to for delightful food delivery, curated menus & tasty meals delivered fast. Enjoy quality cuisine in every order."
        />
      </Helmet>
      <div style={{ overflowX: "hidden" }}>
        <div style={{ overflowX: "hidden" }}>
          <section id="triggerPinned" className="!mt-20 md:!mt-0 !min-h-[60vh] md:min-h-[100vh]">
            <Maitre
              text={t("foodarna.hero.title")}
              desc={t("foodarna.hero.description")}
              imgdata={imagedata}
            />
          </section>
          <section
            className="project-detail"
            style={{
              zIndex: "1",
              color: "black",
            }}
          >
            <Buzzing />
            <Whychoose />
          </section>
          <section
            className="foodrna-footer-section"
            style={{
              zIndex: "1",
              color: "black",
            }}
          >
            <TheArtflavour />
            <FoodrnaContactUs />
          </section>
        </div>
      </div>
    </>
  );
};

export default Foodarna;
